<kendo-grid [data]="bookings" class="table table-responsive" [pageSize]="pageSize" [skip]="skip" [pageable]="true" (pageChange)="pageChange($event)"
  [sortable]="true">
  [height]="510">
  <kendo-grid-column title="Full Name">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.firstNames}} {{dataItem.lastName}}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="gender" title="Gender"></kendo-grid-column>
  <kendo-grid-column field="bookingPrice" title="Price(in US $)"></kendo-grid-column>
  <kendo-grid-column title="Price(in Rand)">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.bookingPrice * 10.91}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column class="text-nowrap" title="Print Confirmations">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="tools modify-tools">
        <button *ngIf="paidForConference$ | async" (click)="viewConf(dataItem.id)" style="color:white;" class="btn-sm btn-success">
          Conference
        </button>
        <button *ngIf="paidForAccommodation$ | async" (click)="viewAccom(dataItem.id)" style="color:white;" class="btn-sm btn-info">
          Accommodation
        </button>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column class="text-nowrap" title="Action">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="tools modify-tools" *ngIf="!(paidForConference$ | async) && !(paidForAccommodation$ | async)">
        <!-- <button (click)="editCurrentBooking(dataItem.id)" style="color:white;" class="btn-sm btn-primary">
          Edit
        </button> -->
        <button (click)="viewCurrentBooking(dataItem)" style="color:white;" class="btn-sm btn-primary">
          Details
        </button>
        <button (click)="deleteBooking(dataItem.id)" style="color:white;" class="btn-sm btn-warning">
          Delete
        </button>
      </div>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/components/list-grid/list-grid.component.html